var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguageLeftImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 129,
    viewBox: "0 0 145 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.3904 60.5803L71.3904 49.2503C73.5604 45.5403 74.8004 41.2303 74.8004 36.6303C74.8004 22.7903 63.5804 11.5703 49.7404 11.5703C35.9004 11.5703 24.6904 22.7903 24.6904 36.6303C24.6904 50.4703 35.9104 61.6903 49.7504 61.6903C56.1304 61.6903 61.9504 59.3003 66.3704 55.3803L76.3904 60.5803Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8603 26.6207C43.8903 24.5107 46.9603 23.4307 50.9803 23.4307C56.3603 23.4307 59.4603 26.5807 59.4603 32.0307V44.5807H53.6803V42.7107C52.7203 43.8307 50.4903 44.8207 48.1003 44.8207C43.5203 44.8207 40.5303 42.1507 40.5303 38.0507C40.5303 35.7807 41.4503 34.1107 43.2403 32.9507C45.0303 31.7907 47.2603 31.2407 49.9303 31.2407C51.4803 31.2407 52.7203 31.4007 53.6703 31.7607C53.7103 29.6907 52.5903 28.8107 50.3203 28.8107C48.0903 28.8107 46.7803 29.2507 44.5903 30.8007L41.8603 26.6207ZM53.6903 37.5007V36.5407C52.7703 36.1807 51.7003 36.0207 50.5403 36.0207C47.8703 36.0207 46.5203 36.7007 46.5203 38.0507C46.5203 39.1707 47.5603 39.8407 49.3103 39.8407C51.2203 39.8507 53.0103 38.8107 53.6903 37.5007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8496 108.61H67.3896V85.8903L73.8396 73.8203L56.3696 83.4603L19.8496 84.5703V108.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5498 88.1201V105.09",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5498 87.5898L38.6098 88.6498",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5498 105.62L38.6098 104.56",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2197 88.6494V105.619",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2197 88.1201L50.2797 89.1801",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2197 106.15L50.2797 105.09",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5498 88.6494H49.2198",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2198 97.1299H37.5498",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2198 104.56H37.5498",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.49 54.87H106.66C105.13 54.87 103.89 53.63 103.89 52.1V39.73C103.89 38.2 105.13 36.96 106.66 36.96H108.49C110.02 36.96 111.26 38.2 111.26 39.73V52.1C111.26 53.63 110.02 54.87 108.49 54.87Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.78 41.5303C99.9901 41.7903 98.6201 43.3103 98.6201 45.1603V48.0203C98.6201 49.8903 100.02 51.4203 101.83 51.6603C101.81 51.5003 101.78 51.3503 101.78 51.1803V41.5303Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.67 36.96H136.5C138.03 36.96 139.27 38.2 139.27 39.73V52.1C139.27 53.63 138.03 54.87 136.5 54.87H134.67C133.14 54.87 131.9 53.63 131.9 52.1V39.73C131.9 38.2 133.14 36.96 134.67 36.96Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.38 50.2999C143.17 50.0399 144.54 48.5199 144.54 46.6699V43.8099C144.54 41.9399 143.14 40.4099 141.33 40.1699C141.35 40.3299 141.38 40.4799 141.38 40.6499V50.2999Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.58 54.8701C135.58 54.8701 136.78 60.6701 127.08 62.3201",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.69 61.6898V59.5098C119.69 58.1298 120.81 57.0098 122.19 57.0098H124.74C126.12 57.0098 127.24 58.1298 127.24 59.5098V61.6898C127.24 63.0698 126.12 64.1898 124.74 64.1898H122.19C120.81 64.1898 119.69 63.0698 119.69 61.6898Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.58 36.9599C107.58 36.9599 107.94 24.9199 121.25 24.9199C134.56 24.9199 135.59 36.9599 135.59 36.9599",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62988 41.6998C5.21988 41.6998 4.80988 41.5398 4.48988 41.2298L1.53988 38.2798C0.909883 37.6498 0.909883 36.6298 1.53988 35.9998C2.16988 35.3698 3.18988 35.3698 3.81988 35.9998L6.76988 38.9498C7.39988 39.5798 7.39988 40.5998 6.76988 41.2298C6.44988 41.5398 6.03988 41.6998 5.62988 41.6998Z",
    stroke: "#748FFC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2904 127.83C31.9304 127.83 31.5704 127.69 31.2904 127.42C30.7404 126.87 30.7404 125.97 31.2904 125.42L33.8804 122.83C34.4304 122.28 35.3304 122.28 35.8804 122.83C36.4304 123.38 36.4304 124.28 35.8804 124.83L33.2904 127.42C33.0104 127.69 32.6504 127.83 32.2904 127.83Z",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5702 17.53C15.0392 17.53 16.2302 16.339 16.2302 14.87C16.2302 13.4009 15.0392 12.21 13.5702 12.21C12.1011 12.21 10.9102 13.4009 10.9102 14.87C10.9102 16.339 12.1011 17.53 13.5702 17.53Z",
    stroke: "#748FFC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6396 107.09C92.5122 107.09 93.2196 106.382 93.2196 105.51C93.2196 104.637 92.5122 103.93 91.6396 103.93C90.767 103.93 90.0596 104.637 90.0596 105.51C90.0596 106.382 90.767 107.09 91.6396 107.09Z",
    stroke: "#748FFC",
    strokeWidth: 1.0504,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7197 1.32031L99.5297 23.1003",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5996 78.2605L36.6496 71.9805",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5 122.58L78.72 112",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23047 52.3604L32.5005 64.5004",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5498 100.35C2.0498 107.88 8.5398 113.57 16.0698 113.08",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.83 102.82C129.82 101.99 132.37 98.0798 131.54 94.0898",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3804 90.8711C105.963 90.8711 112.11 84.724 112.11 77.1411C112.11 69.5583 105.963 63.4111 98.3804 63.4111C90.7975 63.4111 84.6504 69.5583 84.6504 77.1411C84.6504 84.724 90.7975 90.8711 98.3804 90.8711Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0903 89.0909C106.673 89.0909 112.82 82.9437 112.82 75.3609C112.82 67.778 106.673 61.6309 99.0903 61.6309C91.5075 61.6309 85.3604 67.778 85.3604 75.3609C85.3604 82.9437 91.5075 89.0909 99.0903 89.0909Z",
    fill: "#DBE4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2705 78.6304C98.2705 81.4204 103.771 80.4404 106.561 76.4404",
    stroke: "#748FFC",
    strokeWidth: 1.0504,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9806 66.6709L92.8906 68.9709L96.4306 67.8709L95.1506 71.3509L97.2806 74.3709L93.5806 74.2309L91.3606 77.1909L90.3606 73.6309L86.8506 72.4409L89.9306 70.3809L89.9806 66.6709Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2607 65.5705L102.901 64.8705L104.381 61.4805L106.171 64.7205L109.861 65.0905L107.331 67.7905L108.121 71.4105L104.771 69.8405L101.571 71.7105L102.031 68.0305L99.2607 65.5705Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8896 11.2305L92.3297 34.1005",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageLeftImage);
export default __webpack_public_path__ + "static/media/languageLeftImage.19905f43803b95e6127a069352e23ff0.svg";
export { ForwardRef as ReactComponent };